import { render, staticRenderFns } from "./MassMessageEdit.vue?vue&type=template&id=3076a40d&scoped=true&"
import script from "./MassMessageEdit.vue?vue&type=script&lang=ts&"
export * from "./MassMessageEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageEdit.vue?vue&type=style&index=0&id=3076a40d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076a40d",
  null
  
)

export default component.exports